import React, { useState } from 'react'
import Btn from 'components/Btn'
import { UilSchedule, UilTimes } from '@iconscout/react-unicons'
import CustomDatePicker from 'components/CustomDatePicker'
import { withTranslation } from 'react-i18next'
import { MenuItem, Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import dayjs from 'dayjs'
import { useEffect } from 'react'

export default withTranslation()(function DateRange({ t, name, className, getRange = () => null }) {
  const [openState, setCloseState] = useState(false)

  const { setValue, getValues } = useFormContext()
  const range = getValues()?.date_range
  const openRange = () => {
    setCloseState(!openState)
    getRange(getValues().date_range)
  }

  const preSelectedDate = async (unit) => {
    const end_date = dayjs().format('YYYY-MM-DD')
    const start_date = unit !== 'day' ? unit !== 'day' ? dayjs().subtract(1, unit).format('YYYY-MM-DD') : 'all' : dayjs().format('YYYY-MM-DD')
    setValue('date_range', [start_date, end_date])
    openRange()
  }

  const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


  const [date, setDate] = useState()
  useEffect(() => {
    if(range){
      setDate(dayjs(range[0]).format('MMM DD, YYYY') + ' - ' + dayjs(range[1]).format('MMM DD, YYYY'))
    }else{
      setDate(dayjs().format('MMM DD, YYYY') + ' - ' + dayjs().format('MMM DD, YYYY'))
    }
  }, [range])
  const getData = (data) => {
    const start = month[new Date(data[0]).getMonth()] + ' ' + new Date(data[0]).getDate() + ', ' + new Date(data[0]).getFullYear()
    const end = month[new Date(data[1]).getMonth()] + ' ' + new Date(data[1]).getDate() + ', ' + new Date(data[1]).getFullYear()
    setDate(start + ' - ' + end)
  }
  return (
    <div className={`${className} w-fit flex items-center justify-between relative`}>
      <Btn
        className="w-fit md:w-fit h-12 md:h-9 md:-mt-4 bg-input hover:bg-default rounded-md"
        content={() => <div className="w-auto flex items-center justify-between text-[black] gap-[24px]">
          <Typography component={'p'} sx={{ whiteSpace: 'nowrap' }}>{date}</Typography>
          <UilSchedule size={20} className=" block" />
        </div>
        }
        click={openRange}
      />

      {
        (openState) && <div className="fixed top-0 left-0 z-30 w-full h-full bg-black bg-opacity-50 flex">
          <div className="relative m-auto">
            <Btn
              className="w-8 h-8 absolute -right-4 -top-8 md:-right-8 z-30 bg-transparent hover:bg-transparent p-0"
              content={() => <UilTimes className="text-white" size={30} />}
              click={openRange}
            />

            <div className="bg-white p-3 md:p-5 py-3 w-[320px] md:w-full md:max-w-[820px] rounded-md m-auto md:h-auto overflow-y-scroll md:overflow-y-hidden md:flex md:flex-row relative">
              <ul className="border-none w-full overflow-hidden whitespace-nowrap h-14 md:h-auto">
                <MenuItem
                  className="inline-block md:block p-2 m-1 border border-grey-500 md:border-none rounded-md"
                  onClick={() => preSelectedDate('day')}
                >
                  {t('misc.logout.today')}
                </MenuItem>

                <MenuItem
                  className="inline-block md:block p-2 m-1 border-grey-500 md:border-none rounded-md"
                  onClick={() => preSelectedDate('week')}
                >
                  {t('misc.logout.days')}
                </MenuItem>

                <MenuItem
                  className="inline-block md:block p-2 m-1 border-grey-500 md:border-none rounded-md"
                  onClick={() => preSelectedDate('month')}
                >
                  {t('misc.logout.month')}
                </MenuItem>
              </ul>

              <div className="md:border-l relative flex flex-col md:flex-row w-full">
                <CustomDatePicker name={name} getRange={getRange} onAccept={(data) => { setCloseState(false); getData(data) }} />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  )
})